"use client";

import { Provider as StoreProvider } from "jotai";
import React, { PropsWithChildren } from "react";
import { createHomeStore } from "@/store/home";
import type { Tag } from "@/types";

interface HomeProviderProps extends PropsWithChildren {
  tag: Tag;
  counters: {
    byType: Record<string, number>;
  };
}

function HomeProvider({
  tag,
  counters,
  children,
}: Readonly<HomeProviderProps>) {
  const store = createHomeStore(tag, counters);
  return <StoreProvider store={store}>{children}</StoreProvider>;
}

export { HomeProvider, type HomeProviderProps };
